export class CashbackBranchRatioEntity {
  id?: string
  branchId?: number
  branchName?: string | null
  serviceValue?: number | null
  branchValue?: number | null
  branchCap?: number | null
}
